import { render } from "./EduRegisterPage.vue?vue&type=template&id=2ec8aa7c&scoped=true"
import script from "./EduRegisterPage.vue?vue&type=script&lang=js"
export * from "./EduRegisterPage.vue?vue&type=script&lang=js"

import "./EduRegisterPage.vue?vue&type=style&index=0&id=2ec8aa7c&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec8aa7c"]])

export default __exports__